module.exports = __webpack_public_path__ + "img/stratup-brand-logo-4.1b6e594b.png";